"use client"
import React, { useEffect } from 'react'
import { useRouter } from "next/navigation";
import { useAuth } from '@/contexts/AuthContext';
import DefaultLayout from "@/components/Layouts/DefaultLayout";
import PropTypes from 'prop-types';
import SessionWatcher from "@/components/Auth/SessionWatcher";

/**
 * Layout para las rutas protegidas (autenticadas).
 *
 * El "card" gris que envuelve cada página ahora usa tokens semánticos.
 * Antes era `bg-base-100 dark:bg-dark-base-100` directo — sigue
 * funcionando, pero `surface / dark-surface` deja claro a nivel
 * semántico que esto es una "superficie de contenido", lo cual ayuda
 * cuando alguien lee el código en otro archivo.
 */
export default function ProtectedLayout({ children }) {
    const { user, loading } = useAuth();
    const router = useRouter();

    useEffect(() => {
        if (loading === false && !user) {
            // Guardamos la ventana deseada para volver a ella tras iniciar sesión.
            try {
                const dest = window.location.pathname + window.location.search;
                if (dest && dest !== "/auth/signin") {
                    sessionStorage.setItem("postLoginRedirect", dest);
                }
            } catch {
                // ignore
            }
            router.replace('/auth/signin');
        }
    }, [router, user, loading]);

    return (
        <>
            <SessionWatcher />
            <DefaultLayout>
                <div className="card w-full p-8 shadow-sm
                                bg-surface dark:bg-dark-surface
                                border border-border-default dark:border-dark-border-default">
                    {children}
                </div>
            </DefaultLayout>
        </>
    );
}

ProtectedLayout.propTypes = {
    children: PropTypes.node.isRequired,
};
